import "client-only"

export function trackAnalyticsEvent(data: { [key: string]: string }) {
  try {
    window.adobeDataLayer?.push(data)
  } catch (error) {
    console.error("Error in adobeDataLayer.push", error)
  }
}
